import NavMenuButton from './NavMenuButton';

// LoggedInContainer's menu row. The 44px button is placed so its icon sits
// where the old 24px one did, and the negative margin keeps the row 57px tall.
const NavHamburger = (): JSX.Element => (
  <div sx={{ pt: '17px', px: '7px' }}>
    <NavMenuButton id="navHamburger" sx={{ mb: '-4px' }} />
  </div>
);

export default NavHamburger;
